import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldX, ArrowLeft, Mail } from 'lucide-react';
import { useDarkMode } from '../DarkModeContext';

const RestrictedAccess = ({
    title = 'Restricted Access',
    message = 'You do not have permission to access this page.',
    showBackButton = true,
    showContactAdmin = true
}) => {
    const navigate = useNavigate();
    const { darkMode } = useDarkMode();

    return (
        <div className={`min-h-screen flex items-center justify-center p-6 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
            <div className={`max-w-md w-full rounded-2xl p-8 text-center border ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} shadow-xl`}>
                {/* Icon */}
                <div className={`w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center ${darkMode ? 'bg-red-900/30' : 'bg-red-100'}`}>
                    <ShieldX className={`w-10 h-10 ${darkMode ? 'text-red-400' : 'text-red-600'}`} />
                </div>

                {/* Title */}
                <h1 className={`text-2xl font-bold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                    {title}
                </h1>

                {/* Message */}
                <p className={`mb-6 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                    {message}
                </p>

                {/* Info Box */}
                <div className={`rounded-xl p-4 mb-6 ${darkMode ? 'bg-gray-700/50' : 'bg-gray-100'}`}>
                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        If you believe you should have access to this page, please contact your administrator to request the necessary permissions.
                    </p>
                </div>

                {/* Actions */}
                <div className="flex flex-col gap-3">
                    {showBackButton && (
                        <button
                            onClick={() => navigate(-1)}
                            className={`flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-medium transition-all ${
                                darkMode
                                    ? 'bg-gray-700 hover:bg-gray-600 text-white'
                                    : 'bg-gray-200 hover:bg-gray-300 text-gray-900'
                            }`}
                        >
                            <ArrowLeft className="w-5 h-5" />
                            Go Back
                        </button>
                    )}

                    {showContactAdmin && (
                        <button
                            onClick={() => navigate('/halitrade/messages')}
                            className={`flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-medium transition-all ${
                                darkMode
                                    ? 'bg-indigo-600 hover:bg-indigo-700 text-white'
                                    : 'bg-indigo-600 hover:bg-indigo-700 text-white'
                            }`}
                        >
                            <Mail className="w-5 h-5" />
                            Contact Administrator
                        </button>
                    )}
                </div>

                {/* Footer */}
                <p className={`mt-6 text-xs ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                    Error Code: ACCESS_DENIED
                </p>
            </div>
        </div>
    );
};

export default RestrictedAccess;
